import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useLabelsDataDetails } from "./LabelsData.hook";

const ShopAndDineLablesData = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);
  const {
    data: editSubCategories,
    isLoading: drilldownLoading,
    refetch: refetchSubCategories,
  } = useLabelsDataDetails(currentAirport ?? "klia1");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) refetchDocument();
  }, [query.get("id")]);
  useEffect(() => {
    refetchSubCategories();
  }, []);
  console.log("labelsDataaaaaa", editSubCategories);
  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      field_content_en_labelData_searchText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_en?.detailPage?.labelData?.searchText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_en?.detailPage?.labelData?.searchText)
          : "",
      field_content_ms_labelData_searchText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_ms?.detailPage?.labelData?.searchText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_ms?.detailPage?.labelData?.searchText)
          : "",
      field_content_zh_labelData_searchText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_zh?.detailPage?.labelData?.searchText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_zh?.detailPage?.labelData?.searchText)
          : "",
      field_content_en_data_zones_0_label: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_en?.detailPage?.data?.zones?.[0]?.label)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_en?.detailPage?.data?.zones?.[0]?.label)
          : "",
      field_content_ms_data_zones_0_label: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_ms?.detailPage?.data?.zones?.[0]?.label)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_ms?.detailPage?.data?.zones?.[0]?.label)
          : "",
      field_content_zh_data_zones_0_label: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_zh?.detailPage?.data?.zones?.[0]?.label)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_zh?.detailPage?.data?.zones?.[0]?.label)
          : "",
      field_content_en_data_zones_1_label: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_en?.detailPage?.data?.zones?.[1]?.label)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_en?.detailPage?.data?.zones?.[1]?.label)
          : "",
      field_content_ms_data_zones_1_label: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_ms?.detailPage?.data?.zones?.[1]?.label)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_ms?.detailPage?.data?.zones?.[1]?.label)
          : "",
      field_content_zh_data_zones_1_label: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_zh?.detailPage?.data?.zones?.[1]?.label)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_zh?.detailPage?.data?.zones?.[1]?.label)
          : "",
      field_content_en_labelData_categoryText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_en?.detailPage?.labelData?.categoryText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_en?.detailPage?.labelData?.categoryText)
          : "",
      field_content_ms_labelData_categoryText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_ms?.detailPage?.labelData?.categoryText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_ms?.detailPage?.labelData?.categoryText)
          : "",
      field_content_zh_labelData_categoryText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_zh?.detailPage?.labelData?.categoryText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_zh?.detailPage?.labelData?.categoryText)
          : "",
      field_content_en_labelData_zoneText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_en?.detailPage?.labelData?.zoneText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_en?.detailPage?.labelData?.zoneText)
          : "",
      field_content_ms_labelData_zoneText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_ms?.detailPage?.labelData?.zoneText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_ms?.detailPage?.labelData?.zoneText)
          : "",
      field_content_zh_labelData_zoneText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_zh?.detailPage?.labelData?.zoneText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_zh?.detailPage?.labelData?.zoneText)
          : "",
      field_content_en_labelData_levelText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_en?.detailPage?.labelData?.levelText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_en?.detailPage?.labelData?.levelText)
          : "",
      field_content_ms_labelData_levelText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_ms?.detailPage?.labelData?.levelText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_ms?.detailPage?.labelData?.levelText)
          : "",
      field_content_zh_labelData_levelText: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.field_content_zh?.detailPage?.labelData?.levelText)
        : editSubCategories
          ? decodeHTML(editSubCategories?.field_content_zh?.detailPage?.labelData?.levelText)
          : "",
    },
    fields: fields.shopAndDineLabelsData,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    try {
      const payload = {
        action,
        method,
        module: "Shop & Dine",
        subModule: `shopAndDineLabelsData`,
        type: "DEDICATED",
        application: "PASSENGER_ECMS",
        airportName: currentAirport,
        reviewNotes,
        appList: [
          {
            appName: "PASSENGER_ECMS",
            apiUrl,
          },
        ],
        payload: {
          ...(action === "UPDATE" && {
            id: editSubCategories?.id || editSubCategoriesById?.payload?.id,
          }),
          field_content_en: {
            detailPage: {
              data: {
                zones: [
                  {
                    label: data?.field_content_en_data_zones_0_label ?? "",
                    value: "public",
                  },
                  {
                    label: data?.field_content_en_data_zones_1_label ?? "",
                    value: "passenger",
                  },
                ],
              },
              labelData: {
                searchText: data?.field_content_en_labelData_searchText ?? "",
                publicAreaText: data?.field_content_en_data_zones_0_label ?? "",
                passengerAreaText: data?.field_content_en_data_zones_1_label ?? "",
                categoryText: data?.field_content_en_labelData_categoryText ?? "",
                zoneText: data?.field_content_en_labelData_zoneText ?? "",
                levelText: data?.field_content_en_labelData_levelText ?? "",
              },
            },
          },
          field_content_ms: {
            detailPage: {
              data: {
                zones: [
                  {
                    label: data?.field_content_ms_data_zones_0_label ?? "",
                    value: "public",
                  },
                  {
                    label: data?.field_content_ms_data_zones_1_label ?? "",
                    value: "passenger",
                  },
                ],
              },
              labelData: {
                searchText: data?.field_content_ms_labelData_searchText ?? "",
                publicAreaText: data?.field_content_ms_data_zones_0_label ?? "",
                passengerAreaText: data?.field_content_ms_data_zones_1_label ?? "",
                categoryText: data?.field_content_ms_labelData_categoryText ?? "",
                zoneText: data?.field_content_ms_labelData_zoneText ?? "",
                levelText: data?.field_content_ms_labelData_levelText ?? "",
              },
            },
          },
          field_content_zh: {
            detailPage: {
              data: {
                zones: [
                  {
                    label: data?.field_content_zh_data_zones_0_label ?? "",
                    value: "public",
                  },
                  {
                    label: data?.field_content_zh_data_zones_1_label ?? "",
                    value: "passenger",
                  },
                ],
              },
              labelData: {
                searchText: data?.field_content_zh_labelData_searchText ?? "",
                publicAreaText: data?.field_content_zh_data_zones_0_label ?? "",
                passengerAreaText: data?.field_content_zh_data_zones_1_label ?? "",
                categoryText: data?.field_content_zh_labelData_categoryText ?? "",
                zoneText: data?.field_content_zh_labelData_zoneText ?? "",
                levelText: data?.field_content_zh_labelData_levelText ?? "",
              },
            },
          },
          title: "shop-dine-services/shop",
          field_content_html_english: "",
          field_page_content_airport: currentAirport,
          field_page: "shop-dine-services/shop",
          published: true,
        },
        status,
      };

      // Submit to API
      if (query.get("id")) {
        await put(`/management/update-document?approvalId=${query.get("id")}`, payload);
        openToast({
          content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
          type: "success",
        });
        navigate(
          status === "PENDING"
            ? "/dedicated/status-information?activeTab=pending"
            : "/dedicated/status-information?activeTab=draft"
        );
      } else {
        await post("/management/publish", payload);
        openToast({
          content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
          type: "success",
        });
        navigate(
          status === "PENDING"
            ? "/dedicated/status-information?activeTab=pending"
            : "/dedicated/status-information?activeTab=draft"
        );
      }
    } catch (error) {
      openToast({
        content: "Failed to save data",
        type: "error",
      });
      console.error("Error submitting Traveller Essential:", error);
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingSubCategories || drilldownLoading}
      config={epcApplicationsFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${passengerHost}/api/page-content-crud-api-data/${
            editSubCategories?.id || editSubCategoriesById?.payload?.id
          }`,
          "UPDATE",
          "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Shop & Dine"
    />
  );
};

export default ShopAndDineLablesData;
